"use strict";

exports.__esModule = true;
exports.getSubscribeOrAtQuery = exports.getPromiseOrAtQuery = void 0;
const getSubscribeOrAtQuery = (query, at) => {
  return function () {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (at) query.at(at, ...params);
    return query(...params);
  };
};
exports.getSubscribeOrAtQuery = getSubscribeOrAtQuery;
const getPromiseOrAtQuery = (query, at) => {
  return function () {
    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (at) query.at(at, ...params);
    return query(...params);
  };
};
exports.getPromiseOrAtQuery = getPromiseOrAtQuery;